import React from "react";

import { cn } from "@/lib/helpers/cn";
import { useUnreadMessageCount } from "@/features/messaging/api/queries/useUnreadMessageCount";

import { ProfileMenu } from "../ProfileMenu/ProfileMenu";
import { RouteSection } from "../RouteSection/RouteSection";

export function DesktopToolbar(props) {
  const {
    baseRoute,
    customRenderSection,
    handleClickSearch,
    isMessagingEnabled = true,
    isSearchOpen,
    profile,
    routeSection,
    selfSection,
  } = props;

  const { data: messageCount = 0 } = useUnreadMessageCount({ enabled: isMessagingEnabled });

  const renderCustomRenderSection = customRenderSection
    ? customRenderSection.map((section, index) => {
        if (section.isComponent) {
          return (
            <section.render
              key={`section-${index}`}
              messageCount={messageCount}
              {...section.componentProps}
            />
          );
        } else {
          return section.render;
        }
      })
    : [];

  if (selfSection) {
    selfSection["profile"] = profile;
    selfSection["baseRoute"] = baseRoute;
  }

  return (
    <nav
      className={cn(
        "tw:fixed tw:z-201 tw:flex tw:h-(--header-height) tw:w-full tw:justify-center",
        "tw:bg-fill-navy-primary tw:shadow-mdx4",
      )}
    >
      <div
        className={cn(
          "tw:flex tw:w-full",
          "tw:lg:max-w-(--content-max-width-lg) tw:xl:max-w-(--content-max-width-xl)",
          "tw:max-lg:px-8",
        )}
      >
        {routeSection && (
          <RouteSection
            config={routeSection}
            handleClickSearch={handleClickSearch}
            isSearchOpen={isSearchOpen}
            messageCount={messageCount}
          />
        )}

        {renderCustomRenderSection}
        {selfSection && (
          <ProfileMenu baseRoute={selfSection.baseRoute} profile={selfSection.profile} />
        )}
      </div>
    </nav>
  );
}
